import { render, staticRenderFns } from "./TransactionRedemptionResidence.vue?vue&type=template&id=f60c85ee&scoped=true"
import script from "./TransactionRedemptionResidence.vue?vue&type=script&lang=js"
export * from "./TransactionRedemptionResidence.vue?vue&type=script&lang=js"
import style0 from "./TransactionRedemptionResidence.vue?vue&type=style&index=0&id=f60c85ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60c85ee",
  null
  
)

export default component.exports